/**
 * Home-page catalogs for languages that start with one translated page.
 * Keyed by the English source text; anything missing stays in English.
 */
export const homeCatalogs: Record<string, Record<string, string>> = {
  "de": {
    "Skip to content": "Zum Inhalt springen",
    "Guest": "Gast",
    "Works": "Arbeiten",
    "Bio": "Bio",
    "Clipping": "Presse",
    "CV": "Lebenslauf",
    "Contact": "Kontakt",
    "Sound": "Klang",
    "Photo": "Foto",
    "Performance": "Performance",
    "Science": "Wissenschaft",
    "Write": "Texte",
    "Scroll — index": "Scrollen — Index",
    "A body of work by": "Ein Werk von",
    "Transdisciplinary artist · researcher · scientist": "Transdisziplinäre Künstlerin · Forscherin · Wissenschaftlerin",
    "Selected projects": "Ausgewählte Projekte",
    "Menu": "Menü",
    "Elsewhere": "Anderswo",
    "Themes": "Themen",
    "Decolonial Art": "Dekoloniale Kunst",
    "Art, Science & Technology": "Kunst, Wissenschaft & Technologie",
    "Decolonization & Mental Health": "Dekolonisierung & psychische Gesundheit",
    "Sexuality & Gender": "Sexualität & Gender",
    "Madrid, Spain": "Madrid, Spanien",
    "Social": "Soziale Medien",
    "Language": "Sprache",
    "Open menu": "Menü öffnen",
    "Close menu": "Menü schließen",
    "Accessibility options": "Barrierefreiheit",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — Transdisziplinäre Künstlerin",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "Brasilianische politische Künstlerin und Forscherin in Kunst, Wissenschaft und Technologie: psychische Gesundheit, Ritual, Dekolonisierung und indigenes Wissen in Performance, Fotografie und Klang.",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "Politische Kunst zwischen Wissenschaft und Technologie, psychischer Gesundheit, Ritual, Dekolonisierung und indigenem Wissen.",
    "Other pages are in English for now.": "Die übrigen Seiten sind vorerst auf Englisch."
  },
  "fr": {
    "Skip to content": "Aller au contenu",
    "Guest": "Invité·e",
    "Works": "Œuvres",
    "Bio": "Bio",
    "Clipping": "Presse",
    "CV": "CV",
    "Contact": "Contact",
    "Sound": "Son",
    "Photo": "Photo",
    "Performance": "Performance",
    "Science": "Science",
    "Write": "Écrits",
    "Scroll — index": "Défiler — index",
    "A body of work by": "Une œuvre de",
    "Transdisciplinary artist · researcher · scientist": "Artiste transdisciplinaire · chercheuse · scientifique",
    "Selected projects": "Projets choisis",
    "Menu": "Menu",
    "Elsewhere": "Ailleurs",
    "Themes": "Thèmes",
    "Decolonial Art": "Art décolonial",
    "Art, Science & Technology": "Art, science et technologie",
    "Decolonization & Mental Health": "Décolonisation et santé mentale",
    "Sexuality & Gender": "Sexualité et genre",
    "Madrid, Spain": "Madrid, Espagne",
    "Social": "Réseaux",
    "Language": "Langue",
    "Open menu": "Ouvrir le menu",
    "Close menu": "Fermer le menu",
    "Accessibility options": "Options d’accessibilité",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — Artiste transdisciplinaire",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "Artiste politique et chercheuse brésilienne en art, science et technologie : santé mentale, rituel, décolonisation et savoirs autochtones à travers la performance, la photographie et le son.",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "Un art politique entre science et technologie, santé mentale, rituel, décolonisation et savoirs autochtones.",
    "Other pages are in English for now.": "Les autres pages sont pour l’instant en anglais."
  },
  "ja": {
    "Skip to content": "本文へ移動",
    "Guest": "ゲスト",
    "Works": "作品",
    "Bio": "経歴",
    "Clipping": "掲載",
    "CV": "履歴書",
    "Contact": "お問い合わせ",
    "Sound": "サウンド",
    "Photo": "写真",
    "Performance": "パフォーマンス",
    "Science": "サイエンス",
    "Write": "執筆",
    "Scroll — index": "スクロール — 目次",
    "A body of work by": "作品群",
    "Transdisciplinary artist · researcher · scientist": "トランスディシプリナリー・アーティスト · 研究者 · 科学者",
    "Selected projects": "主なプロジェクト",
    "Menu": "メニュー",
    "Elsewhere": "その他",
    "Themes": "テーマ",
    "Decolonial Art": "脱植民地主義のアート",
    "Art, Science & Technology": "アート・サイエンス・テクノロジー",
    "Decolonization & Mental Health": "脱植民地化とメンタルヘルス",
    "Sexuality & Gender": "セクシュアリティとジェンダー",
    "Madrid, Spain": "スペイン・マドリード",
    "Social": "SNS",
    "Language": "言語",
    "Open menu": "メニューを開く",
    "Close menu": "メニューを閉じる",
    "Accessibility options": "アクセシビリティ設定",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — トランスディシプリナリー・アーティスト",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "ブラジルの政治的アーティスト、アート・サイエンス・テクノロジーの研究者。パフォーマンス、写真、サウンドを通して、メンタルヘルス、儀式、脱植民地化、先住民の知を探る。",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "サイエンスとテクノロジー、メンタルヘルス、儀式、脱植民地化、先住民の知を横断する政治的アート。",
    "Other pages are in English for now.": "その他のページは現在英語のみです。"
  },
  "he": {
    "Skip to content": "דילוג לתוכן",
    "Guest": "אורח/ת",
    "Works": "עבודות",
    "Bio": "ביוגרפיה",
    "Clipping": "עיתונות",
    "CV": "קורות חיים",
    "Contact": "צור קשר",
    "Sound": "סאונד",
    "Photo": "צילום",
    "Performance": "פרפורמנס",
    "Science": "מדע",
    "Write": "כתיבה",
    "Scroll — index": "גלילה — מפתח",
    "A body of work by": "גוף עבודות מאת",
    "Transdisciplinary artist · researcher · scientist": "אמנית בין־תחומית · חוקרת · מדענית",
    "Selected projects": "פרויקטים נבחרים",
    "Menu": "תפריט",
    "Elsewhere": "במקומות אחרים",
    "Themes": "נושאים",
    "Decolonial Art": "אמנות דה־קולוניאלית",
    "Art, Science & Technology": "אמנות, מדע וטכנולוגיה",
    "Decolonization & Mental Health": "דה־קולוניזציה ובריאות הנפש",
    "Sexuality & Gender": "מיניות ומגדר",
    "Madrid, Spain": "מדריד, ספרד",
    "Social": "רשתות",
    "Language": "שפה",
    "Open menu": "פתיחת התפריט",
    "Close menu": "סגירת התפריט",
    "Accessibility options": "אפשרויות נגישות",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — אמנית בין־תחומית",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "אמנית פוליטית וחוקרת ברזילאית באמנות, מדע וטכנולוגיה: בריאות הנפש, טקס, דה־קולוניזציה וידע ילידי דרך פרפורמנס, צילום וסאונד.",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "אמנות פוליטית בין מדע וטכנולוגיה, בריאות הנפש, טקס, דה־קולוניזציה וידע ילידי.",
    "Other pages are in English for now.": "שאר העמודים זמינים כרגע באנגלית."
  },
  "ar": {
    "Skip to content": "انتقل إلى المحتوى",
    "Guest": "ضيف",
    "Works": "الأعمال",
    "Bio": "السيرة",
    "Clipping": "الصحافة",
    "CV": "السيرة الذاتية",
    "Contact": "تواصل",
    "Sound": "الصوت",
    "Photo": "التصوير",
    "Performance": "الأداء",
    "Science": "العلوم",
    "Write": "الكتابة",
    "Scroll — index": "مرّر — الفهرس",
    "A body of work by": "مجموعة أعمال",
    "Transdisciplinary artist · researcher · scientist": "فنانة متعددة التخصصات · باحثة · عالمة",
    "Selected projects": "مشاريع مختارة",
    "Menu": "القائمة",
    "Elsewhere": "في أماكن أخرى",
    "Themes": "المحاور",
    "Decolonial Art": "الفن المناهض للاستعمار",
    "Art, Science & Technology": "الفن والعلم والتكنولوجيا",
    "Decolonization & Mental Health": "إنهاء الاستعمار والصحة النفسية",
    "Sexuality & Gender": "الجنسانية والنوع الاجتماعي",
    "Madrid, Spain": "مدريد، إسبانيا",
    "Social": "التواصل الاجتماعي",
    "Language": "اللغة",
    "Open menu": "افتح القائمة",
    "Close menu": "أغلق القائمة",
    "Accessibility options": "خيارات إمكانية الوصول",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — فنانة متعددة التخصصات",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "فنانة سياسية وباحثة برازيلية في الفن والعلم والتكنولوجيا: الصحة النفسية والطقوس وإنهاء الاستعمار ومعارف الشعوب الأصلية عبر الأداء والتصوير والصوت.",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "فن سياسي يعبر العلم والتكنولوجيا والصحة النفسية والطقوس وإنهاء الاستعمار ومعارف الشعوب الأصلية.",
    "Other pages are in English for now.": "الصفحات الأخرى متاحة حاليًا بالإنجليزية."
  },
  "zh": {
    "Skip to content": "跳到内容",
    "Guest": "访客",
    "Works": "作品",
    "Bio": "简介",
    "Clipping": "媒体报道",
    "CV": "简历",
    "Contact": "联系",
    "Sound": "声音",
    "Photo": "摄影",
    "Performance": "行为艺术",
    "Science": "科学",
    "Write": "写作",
    "Scroll — index": "滚动 — 索引",
    "A body of work by": "作品集",
    "Transdisciplinary artist · researcher · scientist": "跨学科艺术家 · 研究者 · 科学家",
    "Selected projects": "精选项目",
    "Menu": "菜单",
    "Elsewhere": "其他",
    "Themes": "主题",
    "Decolonial Art": "去殖民艺术",
    "Art, Science & Technology": "艺术、科学与技术",
    "Decolonization & Mental Health": "去殖民化与心理健康",
    "Sexuality & Gender": "性与性别",
    "Madrid, Spain": "西班牙马德里",
    "Social": "社交媒体",
    "Language": "语言",
    "Open menu": "打开菜单",
    "Close menu": "关闭菜单",
    "Accessibility options": "无障碍选项",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — 跨学科艺术家",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "巴西政治艺术家，艺术、科学与技术研究者：通过行为艺术、摄影和声音探讨心理健康、仪式、去殖民化与原住民知识。",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "横跨科学与技术、心理健康、仪式、去殖民化与原住民知识的政治艺术。",
    "Other pages are in English for now.": "其他页面目前为英文。"
  },
  "hi": {
    "Skip to content": "सामग्री पर जाएँ",
    "Guest": "अतिथि",
    "Works": "कृतियाँ",
    "Bio": "परिचय",
    "Clipping": "प्रेस",
    "CV": "सीवी",
    "Contact": "संपर्क",
    "Sound": "ध्वनि",
    "Photo": "फ़ोटो",
    "Performance": "परफ़ॉर्मेंस",
    "Science": "विज्ञान",
    "Write": "लेखन",
    "Scroll — index": "स्क्रॉल करें — सूची",
    "A body of work by": "कृतियों का संग्रह",
    "Transdisciplinary artist · researcher · scientist": "अंतर्विषयी कलाकार · शोधकर्ता · वैज्ञानिक",
    "Selected projects": "चुनी हुई परियोजनाएँ",
    "Menu": "मेनू",
    "Elsewhere": "अन्यत्र",
    "Themes": "विषय",
    "Decolonial Art": "विउपनिवेशी कला",
    "Art, Science & Technology": "कला, विज्ञान और प्रौद्योगिकी",
    "Decolonization & Mental Health": "विउपनिवेशीकरण और मानसिक स्वास्थ्य",
    "Sexuality & Gender": "यौनिकता और जेंडर",
    "Madrid, Spain": "मैड्रिड, स्पेन",
    "Social": "सोशल",
    "Language": "भाषा",
    "Open menu": "मेनू खोलें",
    "Close menu": "मेनू बंद करें",
    "Accessibility options": "सुलभता विकल्प",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — अंतर्विषयी कलाकार",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "ब्राज़ील की राजनीतिक कलाकार और कला, विज्ञान व प्रौद्योगिकी की शोधकर्ता: परफ़ॉर्मेंस, फ़ोटोग्राफ़ी और ध्वनि के माध्यम से मानसिक स्वास्थ्य, अनुष्ठान, विउपनिवेशीकरण और देशज ज्ञान।",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "विज्ञान और प्रौद्योगिकी, मानसिक स्वास्थ्य, अनुष्ठान, विउपनिवेशीकरण और देशज ज्ञान को जोड़ती राजनीतिक कला।",
    "Other pages are in English for now.": "बाकी पन्ने अभी अंग्रेज़ी में हैं।"
  },
  "ru": {
    "Skip to content": "Перейти к содержанию",
    "Guest": "Гость",
    "Works": "Работы",
    "Bio": "Биография",
    "Clipping": "Пресса",
    "CV": "Резюме",
    "Contact": "Контакты",
    "Sound": "Звук",
    "Photo": "Фото",
    "Performance": "Перформанс",
    "Science": "Наука",
    "Write": "Тексты",
    "Scroll — index": "Прокрутка — указатель",
    "A body of work by": "Корпус работ",
    "Transdisciplinary artist · researcher · scientist": "Трансдисциплинарная художница · исследовательница · учёная",
    "Selected projects": "Избранные проекты",
    "Menu": "Меню",
    "Elsewhere": "Другое",
    "Themes": "Темы",
    "Decolonial Art": "Деколониальное искусство",
    "Art, Science & Technology": "Искусство, наука и технологии",
    "Decolonization & Mental Health": "Деколонизация и психическое здоровье",
    "Sexuality & Gender": "Сексуальность и гендер",
    "Madrid, Spain": "Мадрид, Испания",
    "Social": "Соцсети",
    "Language": "Язык",
    "Open menu": "Открыть меню",
    "Close menu": "Закрыть меню",
    "Accessibility options": "Настройки доступности",
    "Luiza Jesus do Prado — Transdisciplinary Artist": "Luiza Jesus do Prado — трансдисциплинарная художница",
    "Brazilian political artist and researcher in art, science and technology: mental health, ritual, decolonization and Indigenous knowledge.": "Бразильская политическая художница и исследовательница в области искусства, науки и технологий: психическое здоровье, ритуал, деколонизация и знания коренных народов в перформансе, фотографии и звуке.",
    "Political art across science and technology, mental health, ritual, decolonization and Indigenous knowledge.": "Политическое искусство на стыке науки и технологий, психического здоровья, ритуала, деколонизации и знаний коренных народов.",
    "Other pages are in English for now.": "Остальные страницы пока на английском."
  }
};
